<template>
    <div>
        <div class="post__body__placeholder flex"
            v-if="!loaded"
        >
            <Spinner
                :size="60"
                :color="'#3897f0'"
            ></Spinner>
        </div>
        <transition
            name="fade-button"
        >
            <img
            v-show="loaded"
            :src="imgPath"
            v-on:load="loadedImg"
            @click="showModal(postNumber, number)"
            >
        </transition>
    </div>
</template>

<script>
import loadProtectedImage from '@/utils/loadProtectedImage'
import { mapState } from 'vuex'

export default {
    props: {
        path: {
            type: String,
            required: true
        },
        number: {
            type: Number,
            required: true
        },
        postNumber: {
            type: Number,
            required: true
        }
    },
    data(){
        return {
            observer: null,
            intersected: false,
            loaded: false,
            blobUrl: ''
        }
    },
    computed: {
        ...mapState(['token']),
        imgPath() {
            return this.blobUrl;
        }
    },
    watch: {
        async intersected(isIntersected) {
            if (isIntersected && this.path && this.token) {
                this.blobUrl = await loadProtectedImage(this.path, this.token);
            }
        }
    },
    mounted() {
        this.observer = new IntersectionObserver( entries => {
            const image = entries[0];

            if(image.isIntersecting) {
                this.intersected = true;
            }
        });

        this.observer.observe(this.$el)
    },
    destroyed() {
        this.observer.disconnect();
        // Clean up blob URL to prevent memory leak
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
        }
    },
    methods: {
        loadedImg(){
            this.loaded = true;
        },
        showModal(index1, index2){
            const postIndexes = [];
            postIndexes.push(index1);
            postIndexes.push(index2);
            this.$store.dispatch('getImageModalSrc', postIndexes);
        }
    }
}
</script>

